import deepmerge from 'deepmerge'
import { GetServerSidePropsResult, GetStaticPropsContext, GetStaticPropsResult } from 'next'

import { MenuData } from '../models/header'
import { footerData, footerQuery } from './footer'
import { headerData, headerQuery } from './header'

export type GlobalContextType = {
  header?: MenuData
  footer?: MenuData
}

export type GlobalProps = {
  globals: GlobalContextType
}

export type Result<T> =
  GetStaticPropsResult<Partial<GlobalProps & T>>
  | GetServerSidePropsResult<Partial<GlobalProps & T>>

export const getLayoutProps = () => {
  return {
    globals: {
      header: headerData,
      footer: footerData,
    },
  }
}

export const layoutQuery = async (context: GetStaticPropsContext) => {
  const header = await headerQuery(context)
  const footer = await footerQuery(context)

  return { header, footer }
}

export const withLayoutProps = async <T>(context: GetStaticPropsContext, result?: Result<T>) => {
  const globals = await layoutQuery(context)

  if (!result) {
    return {
      props: { globals },
    }
  }

  if ('props' in result) {
    return {
      ...result,
      props: deepmerge(await result.props, { globals }),
    }
  }
  
  return {
    props: { globals },
  }
}